import { createContext as o, useContext as e } from "react";
import { a as t } from "../../../vanilla-CSAfDK5R.js";
const s = () => ({
  idAtom: t(""),
  sizeAtom: t("md")
}), m = o(s()), r = () => e(m);
export {
  m as ListContext,
  s as createListState,
  r as useListStateAtoms
};
//# sourceMappingURL=index.js.map
